// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".profile-sync .action{width:100%;display:flex;align-items:center;justify-content:flex-start;margin-bottom:1.5rem}.profile-sync .action:last-child{margin-bottom:0}.profile-sync .action .success{margin-left:1rem}.profile-sync .action .success i{margin-right:.5rem}.profile-sync .label{width:100%;font-size:.875rem;display:block;margin-bottom:.5rem}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
